import React, { type FunctionComponent } from 'react'
import { useIntl, type FormatNumberOptions } from 'react-intl'

import { LabeledNumber } from 'legacy/routes/orders/details/components/LabeledNumber'

const numberOptions: FormatNumberOptions = { style: 'currency', currency: 'USD' }

export type ChargeCellProps = {
  quantity: string
  unitPrice: number
  charge: number
}

const ChargeCell: FunctionComponent<ChargeCellProps> = ({ quantity, unitPrice, charge }) => {
  const intl = useIntl()
  return (
    <div>
      <LabeledNumber label="Qty" value={quantity} />
      <LabeledNumber label="Unit" value={intl.formatNumber(unitPrice, numberOptions)} />
      <LabeledNumber label="Charge" value={intl.formatNumber(charge, numberOptions)} />
    </div>
  )
}

export default ChargeCell
